import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ConfigService } from '../service/config.service';
import { BrowserUtil } from '../utils/browser.util';

@Directive({
  selector: '[toggleCamera]'
})
export class ToggleCameraDirective implements OnInit {
  @Input('toggleCamera') secureOrInsecure: string;
  @Input('appAcceptFormats') appAcceptFormats: string;

  constructor(private hostElement: ElementRef, private renderer: Renderer2,
    private configService: ConfigService, private browserUtil: BrowserUtil) {
  }

  ngOnInit() {
    let featureName = (this.secureOrInsecure == 'SecureFile') ? "captureSecureFiles" : "captureInsecureFiles";
    if (this.configService.featureOn(featureName)) {
      this.renderer.setAttribute(this.hostElement.nativeElement, 'capture', "camera");
      this.renderer.setAttribute(this.hostElement.nativeElement, 'accept', "image/*");
      const applicableFormats = this.browserUtil.isFacebookBrowser() ? null : this.appAcceptFormats;
      if (applicableFormats && applicableFormats != '') {
        this.renderer.setAttribute(this.hostElement.nativeElement, 'accept', applicableFormats);
      }

    }
  }
}